import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

//import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)
 import de from "vuetify/lib/locale/de";
import en from "vuetify/lib/locale/en";
const opts = {
    iconfont: 'md',
    lang: {
        locales: { de,en },
        current: 'en',
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#1A1A1A',
                secondary: '#FFFFFF',
                accent: '#E57272',
                error: '#FF5252',
                info: '#104380',
                success: '#4CAF50',
                warning: '#FFC107',
                text: '#F2F2F2',
                white: '#FFFFFF',
                grey: '#F7F8FA',
                whitevariant: '#F4F4F4',
                lightblack:'#1A1A1A',
                background:'#e5e5e566'
            },
            dark: {
            primary: '#FFFFFF',
            secondary: '#1e1e1e',
            whitevariant: '#292929',
            background: '#e5e5e566'
                            },
        },
    }

}



export default new Vuetify(opts)